import AddToCartIcon from "./AddToCartIcon";
import { useTranslation } from "react-i18next";
export const SymbolsExpalanation = ({ selectedDiagramId, onRequestCartMessage }: { selectedDiagramId: string | undefined; onRequestCartMessage: string }) => {
  const { t } = useTranslation();

  return (
    <div className="ps-5">
      {selectedDiagramId && (
        <div>
          <div className="flex">
            <AddToCartIcon tint={"#008001"} />
            <strong className="ms-1 text-black lg:text-md text-xs">{t("in_stock")}</strong>
          </div>
          <div className="flex mt-2">
            <AddToCartIcon tint={"#FFA500"} />
            <strong className="ms-1 text-black lg:text-md text-xs">{onRequestCartMessage}</strong>
          </div>
        </div>
      )}
    </div>
  );
};
